import './AppLogo.scss'
import type { VFC, SyntheticEvent } from 'react'

const EMPTY_SVG = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>'

const imageLoadError = ({ currentTarget }: SyntheticEvent<HTMLImageElement>) => {
  currentTarget.onerror = null // prevents looping
  currentTarget.src = EMPTY_SVG
}

const AppLogo: VFC<{ src: string | undefined, alt: string }> = ({ src, alt }) => {
  return <div className='sparky-hub-app-logo'>
    <img className='sparky-hub-app-logo-img' src={src || EMPTY_SVG} alt={alt} onError={imageLoadError} />
  </div>
}

export default AppLogo
